import { useEffect } from 'react';
import { useLatest } from './useLatest';

export interface KeyboardShortcutHandlers {
  readonly onUndo?: () => void;
  readonly onRedo?: () => void;
}

/** Global undo/redo shortcuts. Focused-note shortcuts live in Note itself. */
export function useKeyboardShortcuts(handlers: KeyboardShortcutHandlers): void {
  const ref = useLatest(handlers);
  useEffect(() => {
    const handler = (event: KeyboardEvent) => {
      const target = event.target as HTMLElement | null;
      if (target && isTextInput(target)) return;

      const mod = event.metaKey || event.ctrlKey;
      if (!mod) return;
      const key = event.key.toLowerCase();

      if (key === 'z' && !event.shiftKey) {
        event.preventDefault();
        ref.current.onUndo?.();
      } else if ((key === 'z' && event.shiftKey) || key === 'y') {
        event.preventDefault();
        ref.current.onRedo?.();
      }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [ref]);
}

function isTextInput(el: HTMLElement): boolean {
  const tag = el.tagName;
  if (tag === 'INPUT' || tag === 'TEXTAREA') return true;
  return el.isContentEditable;
}
